if (!customElements.get("recently-viewed")) {
  class RecentlyViewed extends HTMLElement {
    constructor() {
      super();

      this.productHandle = null;
      this.productLimit = null;
    }

    connectedCallback() {
      setTimeout(() => {
        this.initIntersectionObserver();
      }, 0);
    }
    
    initIntersectionObserver() {
      if (typeof Cookie == null) return;
      let cookie = Cookies.get("recentlyViewed");
      if (!cookie || cookie === "undefined") {
        this.style.display = 'none';
        return;
      }
    
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;

        observer.unobserve(this);
        this.productHandle = this.dataset.productHandle;
        this.productLimit = this.dataset.productLimit;
        
        if (cookie != "undefined") {
          if (!this.productLimit) {
            console.error("Error: productLimit is not set.");
            this.style.display = 'none';
            return;
          }
        } else if (!this.productHandle || !this.productLimit) {
          console.error("Error: productHandle or productLimit is not set.");
          this.style.display = 'none';
          return;
        }
        this.setRecentlyViewedProducts();
      };
    
      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: "0px 0px 1000px 0px",
      }).observe(this);
    }

    setRecentlyViewedProducts() {
      const productHandles = this.getProductHandles(this.productHandle);
      let productHandlesArray = [];
      if (productHandles) {
        productHandlesArray = decodeURI(productHandles).split(",");
      }

      let productsToRender = productHandlesArray;

      if (this.productHandle) {
        if (productHandlesArray.includes(this.productHandle)) {
          productsToRender = productHandlesArray.filter((handle) => {
            return handle !== this.productHandle;
          });
        } else {
          let newHandles = [this.productHandle].concat(productHandlesArray);
          this.setCookieProducts(newHandles);
        }
      }

      if (productsToRender.length > 0) {
        this.renderProducts(productsToRender);
      }
    }

    getProductHandles(productHandle) {
      let productHandles = Cookies.get("recentlyViewed");
      if (!productHandles) {
        Cookies.set("recentlyViewed", productHandle, {
          expires: 30,
          path: "/",
        });
        productHandles = Cookies.get("recentlyViewed");
      }
      return productHandles;
    }

    renderProducts(productsToRender) {
      if (this.productLimit && productsToRender.length > 0) {
        productsToRender = productsToRender.slice(0, this.productLimit);
      }

      const productWrapper = this.querySelector("[data-products-wrapper]");
      const fetchPromises = [];
      productsToRender.forEach((value) => {
        const fetchPromise = fetch("/products/" + value + "?view=rv")
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement("div");
            html.innerHTML = text;

            const title = html.querySelector('.product-single__title').innerHTML;
            const price = html.querySelector('.td-active-price-container').innerHTML;
            const cylindo = html.querySelector('.visually-hidden .td-cylindo-image-render img');
            let img = (html.querySelectorAll('.td--pg__media img'))[0];
            if (cylindo) {
              img = cylindo.dataset
            }

            const card = '<div class="swiper-slide" data-swiper-slide><a href="/products/' + value + '" class="td-featured-collections__card"><img src='+ img.src +' srcset="'+ img.srcset +'" alt="'+ img.alt +'" width="1200" height="675" loading="lazy" class="td-featured-collections__card-title-img td-img td-img--contain"/><div class="td-featured-collections__card-title">'+ title +'</div><div class="td-featured-collections__card-price"><span>from </span>'+ price +'</div></a></div>';
            productWrapper.insertAdjacentHTML('beforeend', card);
          })
          .catch((e) => {
            console.error(e);
          });

          fetchPromises.push(fetchPromise);
      });

      this.classList.add("td-recently-viewed__initialized");

      Promise.all(fetchPromises).then(() => {
        const swiper = this.querySelector(".swiper-slider-container");
        const recentlyViewedRendered = new Event('reinitialize-swiper');
        swiper.dispatchEvent(recentlyViewedRendered);
      });
    }

    setCookieProducts(productHandlesArray) {
      Cookies.set("recentlyViewed", decodeURI(productHandlesArray.join(",")), {
        expires: 30,
        path: "/",
      });
    }
  }
  customElements.define("recently-viewed", RecentlyViewed);
}